// extracted by mini-css-extract-plugin
export var anchor = "_4u-0";
export var discard = "_4u-4";
export var muiTooltipTooltip = "_4u-6";
export var notificationBar = "_4u-3";
export var saveButtonHoverSlotWrapper = "_4u-5";
export var show = "_4u-2";
export var spacer = "_4u-1";